import { useSearch } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { toast } from 'sonner'

export const useSubscriptionSuccessToast = () => {
  const search = useSearch({
    from: '/_dashboard/settings',
  })
  const done = useRef(false)

  useEffect(() => {
    if (search.subscription) {
      if (!done.current) {
        done.current = true
        toast.success('Your Lawfully Pro subscription is now active.')
      }
    }

    return () => {
      done.current = false
    }
  }, [search.subscription])

  return null
}
